import React from "react";
import { FaTiktok } from "react-icons/fa";
import Navbar from "../../components/Navbar/Navbar";
import ListProducts from "../../components/ListProducts/ListProducts";

const TIKTOK_URL = "https://www.tiktok.com/@auravibe.ks?lang=en";
const HERO_IMAGE =
  "https://images.unsplash.com/photo-1577962272294-564f38f71d90?auto=format&fit=crop&w=1920&q=85";

const scrollToProducts = () => {
  document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
};

const Home = () => {
  return (
    <div className="min-h-screen bg-[#000000] font-playfair">
      <Navbar />

      {/* Hero with background image */}
      <section
        className="relative overflow-hidden bg-[#000000] text-[#ffffff] min-h-[70vh] flex items-center"
        aria-label="Hero"
      >
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        />
        <div className="absolute inset-0 bg-[#000000]/45" />
        <div className="absolute inset-0 opacity-20">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 40px,
                rgba(224,216,195,0.3) 40px,
                rgba(224,216,195,0.3) 41px
              )`,
            }}
          />
        </div>
        <div className="relative mx-auto max-w-6xl w-full px-4 py-16 sm:py-20 md:py-24">
          <div className="max-w-2xl">
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#e0d8c3]">
              Parfume të zgjedhura
            </p>
            <h1 className="text-4xl font-bold tracking-tight text-[#ffffff] sm:text-5xl md:text-6xl">
              Zbuloni aromën tuaj
            </h1>
            <p className="mt-5 text-lg text-[#e0d8c3]/95 sm:text-xl">
              Koleksion parfumesh për burra dhe gra. Cilësi dhe çmime të volitshme.
            </p>
            <button
              type="button"
              onClick={scrollToProducts}
              className="mt-8 inline-flex items-center gap-2 rounded-xl border-2 border-[#e0d8c3] bg-[#e0d8c3] px-6 py-3.5 text-base font-semibold text-[#000000] transition hover:bg-[#e0d8c3]/90 hover:border-[#e0d8c3]/90 active:scale-[0.98]"
            >
              Shiko produktet
            </button>
          </div>
        </div>
      </section>

      {/* Who we are */}
      <section className="relative border-y border-[#a6a6a6]/30 bg-[#000000] py-16 sm:py-20">
        <div className="mx-auto max-w-4xl px-4 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-[#ffffff] sm:text-3xl">
            Kush jemi ne
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#e0d8c3] sm:text-xl">
            Jemi Aura Parfumes — një dyqan i përkushtuar ndaj parfumeve me cilësi për burra dhe gra.
            Ofertojmë aroma të zgjedhura dhe origjinale që përshtaten me stilin tuaj. Qëllimi ynë është
            t’ju ndihmojmë të zbuloni aromën tuaj të veçantë me çmime të volitshme dhe shërbim të
            besueshëm.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#a6a6a6] sm:text-lg">
            Na ndiqni në TikTok për këshilla dhe rekomandime.
          </p>
        </div>
      </section>

      {/* Products */}
      <section id="products" className="bg-[#000000] py-8 sm:py-12 scroll-mt-4" aria-label="Produktet">
        <ListProducts />
      </section>

      {/* Footer */}
      <footer className="border-t border-[#a6a6a6]/40 bg-[#000000] py-8">
        <div className="mx-auto max-w-6xl px-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-center">
          <p className="text-sm font-medium text-[#e0d8c3]">
            Aura Parfumes · Parfume me cilësi
          </p>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#e0d8c3] hover:opacity-80 transition-opacity"
            aria-label="TikTok Aura Vibe"
          >
            <FaTiktok className="w-6 h-6" />
            <span className="text-sm font-medium">TikTok</span>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
